module.exports = __webpack_public_path__ + "img/Videopublicity-play.7ed11924.png";